import { useQuery } from "@tanstack/react-query";
import {
  PROPERTY_SHIELD_INTEGRATION_KEY,
  propertyShieldApi
} from "api/propertyShield";

/** Open to every partner: connecting is how Listing Fraud Alerts is turned on. */
export const usePropertyShieldIntegration = () =>
  useQuery({
    queryKey: [PROPERTY_SHIELD_INTEGRATION_KEY],
    queryFn: propertyShieldApi.getIntegration
  });
